import HeaderLogo from '../../assets/svg/HeaderLogo.svg';
import JDFLogo from '../../assets/svg/jdf_logo.svg';
import Clock from '../../assets/svg/clock-3.svg';
import Check from '../../assets/svg/check.svg';
import ShieldCheck from '../../assets/svg/shield-check.svg';
import {postAPICall} from '../../services/apiCallsHandler';

import {Button, LinearProgress} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './postVerificationComponent.css';

const PostVerificationComponent = (props) => {
  const {t} = useTranslation();
  const [isLoading, setIsLoading] = React.useState(true);
  const [failureCount, setFailureCount] = React.useState(0);
  const [maskedEmail, setMaskedEmail] = React.useState(null);
  const retryExhausted = failureCount >= 2;

  const handlePostVerification = async () => {
    setIsLoading(true);
    const res = await postAPICall(
      'postSecurityVerification',
      {custId: props.custId, countryCode: props.country},
      {
        isCallBack: false,
        errorTag: 'POST_SECURITY_VERIFICATION',
        redirectToOops: false,
      }
    );
    setIsLoading(false);
    if (res.status === 200) {
      props.onPostVerificationSuccess();
    } else {
      setMaskedEmail(res.body?.maskedEmail || null);
      setFailureCount((count) => count + 1);
    }
  };

  React.useEffect(() => {
    handlePostVerification();
  }, []);

  return (
    <div className="postVerificationPage">
      <header className="postVerificationHeader">
        <img src={HeaderLogo} alt="John Deere Financial" />
        <span>My Financial</span>
      </header>
      <main className="postVerificationComponentWrapper">
        <div className="postVerificationHeading">
          <img src={JDFLogo} alt="John Deere Financial" />
          <h1>{t('POST_SETUP_TITLE')}</h1>
          <p>{t('POST_SETUP_WELCOME')}</p>
        </div>
        <ol
          className="postVerificationSteps"
          aria-label={t('POST_SETUP_PROGRESS')}
        >
          {[
            'POST_SETUP_VERIFICATION',
            'POST_SETUP_ACCOUNT',
            'POST_SETUP_SETUP',
          ].map((step, index) => (
            <li
              key={step}
              className={index < 2 ? 'complete' : 'pending'}
              aria-current={index === 2 ? 'step' : undefined}
            >
              <span className="postVerificationStepIcon" aria-hidden="true">
                {index < 2 ? <img src={Check} alt="" /> : '3'}
              </span>
              <div>
                <span>{t(step)}</span>
                <small>
                  {t(
                    index < 2 ? 'POST_SETUP_COMPLETE' : 'POST_SETUP_IN_PROGRESS'
                  )}
                </small>
              </div>
            </li>
          ))}
        </ol>
        <section
          className="postVerificationBody"
          aria-live="polite"
          aria-busy={isLoading}
        >
          <span className="postVerificationBadge">
            <img src={Clock} alt="" /> {t('POST_SETUP_SETUP')}
          </span>
          {isLoading ? (
            <>
              <h2>{t('POST_SECURITY_LOADING_HEADING')}</h2>
              <p>{t('POST_SECURITY_LOADING_SUB_HEADING')}</p>
              <LinearProgress id="postVerificationLoader" />
            </>
          ) : (
            <>
              <h2>
                {t(
                  retryExhausted
                    ? 'POST_SETUP_FINAL_HEADING'
                    : 'POST_SETUP_FIRST_HEADING'
                )}
              </h2>
              {retryExhausted ? (
                <p>
                  {t('POST_SETUP_FINAL_BEFORE_EMAIL')}{' '}
                  <strong>{maskedEmail || t('YOUR_REGISTERED_EMAIL')}</strong>{' '}
                  {t('POST_SETUP_FINAL_AFTER_EMAIL')}
                </p>
              ) : (
                <p>{t('POST_SETUP_FIRST_DESCRIPTION')}</p>
              )}
              <p className="postVerificationSaved">
                <img src={ShieldCheck} alt="" /> {t('POST_SETUP_SAVED')}
              </p>
              {!retryExhausted && (
                <>
                  <div className="postVerificationNext">
                    <h3>{t('POST_SETUP_NEXT')}</h3>
                    <ol>
                      <li>{t('POST_SETUP_NEXT_RETRY')}</li>
                      <li>{t('POST_SETUP_NEXT_READY')}</li>
                    </ol>
                  </div>
                  <div className="postVerificationActions">
                    <Button
                      type="button"
                      variant="primary"
                      id="retryButton"
                      onClick={handlePostVerification}
                    >
                      {t('POST_SECURITY_BUTTON_RETRY')}
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default PostVerificationComponent;
